// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"1592f9e6","152":"c86c6d49","190":"b95c1bdc","217":"4bede6fc","349":"136934c4","523":"f49737b6","777":"bc147ad4","905":"2174086d","972":"772343d4","987":"28b168f5"}[chunkId] + ".chunk.js";
};